const state = () => ({
  sourceList: [], // 学员来源
  levelList: [], // 意向级别
  importanceLevelList: [], // 重要程度
  followUserList: [], // 跟进人
  transferUserList: [], // 转让人
  packageList: [], // 套餐下拉列表
  courseOptions: [] ,// 课程下拉
  birthdayDays: 15, // 生日提醒
  orderLabel: [], // 订单标签
  classTag: [], // 班级标签
});
const mutations = {
  setBirthdayDays (state, data) {
    state.birthdayDays = data;
  },
  setSourceList(state, data) {
    state.sourceList = data;
  },
  setLevelList(state, data) {
    state.levelList = data;
  },
  setImportanceLevelList(state, data) {
    state.importanceLevelList = data;
  },
  setFollowUserList(state, data) {
    state.followUserList = data;
  },
  setTransferUserList(state, data) {
    state.transferUserList = data;
  },
  setPackageList(state, data) {
    state.packageList = data;
  },
  setCourseOptions(state, data) {
    state.courseOptions = data;
  },
  setClassTag(state, data) {
    state.classTag = data;
  },
  setOrderLabel(state, data) {
    state.orderLabel = data;
  },
};
const actions = {};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
